import ApiService from '@/api/ApiService'
import proxy from '@/shared/proxy'

const LatestPoliciesService = {

  GetTermsAndConditions () {
    return ApiService.getAsync(proxy.Userv2, 'Policies/Latest/TermsAndConditions')
  },

  GetPrivacyPolicy () {
    return ApiService.getAsync(proxy.Userv2, 'Policies/Latest/PrivacyPolicy')
  }
}
export default LatestPoliciesService
